import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { getEmojisByCategory, emojiCategories } from '../data/emojiData';
import './CategoryPage.css';

const CategoryPage = () => {
  const { name } = useParams();
  const [searchQuery, setSearchQuery] = useState('');
  const [emojis, setEmojis] = useState([]);
  
  useEffect(() => {
    // Get emojis for this category
    const categoryEmojis = getEmojisByCategory(name);
    setEmojis(categoryEmojis);
  }, [name]);
  
  // Filter emojis based on search query
  const filteredEmojis = searchQuery 
    ? emojis.filter(emoji => 
        emoji.keyword.toLowerCase().includes(searchQuery.toLowerCase()) ||
        emoji.description.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : emojis;
  
  const category = emojiCategories[name] || {
    name: 'Category Not Found',
    description: 'Sorry, this category does not exist',
    icon: '❓'
  };
  
  const handleSearch = (e) => {
    e.preventDefault();
    // Search is handled by the state already
  };
  
  const pageTitle = `${category.icon} ${category.name} - Copy and Paste | GifsCopyPaste.com`;
  const metaDescription = `Browse and copy ${category.name.toLowerCase()} easily. ${category.description}. Free and simple to use.`;

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:type" content="website" />
      </Helmet>
    
      <div className="category-page">
        <div className="container">
          <div className="category-header">
            <Link to="/" className="back-button">← Back to Home</Link>
          </div>
          
          <h1 className="category-title">{category.icon} {category.name}</h1>
          <p className="category-description">{category.description}</p>
          
          <div className="search-container">
            <form onSubmit={handleSearch}>
              <input 
                type="text" 
                className="search-input" 
                placeholder="Search in this category..." 
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <button type="submit" className="search-button">🔍</button>
            </form>
          </div>
          
          {filteredEmojis.length > 0 ? (
            <div className="emoji-grid">
              {filteredEmojis.map(emoji => (
                <Link to={`/emoji/${emoji.id}`} key={emoji.id} className="emoji-card">
                  <div className="emoji-display">{emoji.emoji}</div>
                  <div className="emoji-name">{emoji.keyword}</div>
                  <button className="copy-button">View & Copy</button>
                </Link>
              ))}
            </div>
          ) : (
            <p className="no-results">
              {searchQuery 
                ? "No emojis found matching your search. Try a different search term." 
                : "No emojis found in this category."}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default CategoryPage;
